<template>
    <!-- 上下结构 图片+文字 -->
    <el-row :gutter="20" type="flex" style="flex-wrap:wrap">
        <el-col :xs="12" :sm="12" :md="6" class="elBg" v-for="(item, index) in imgList" :key="index" style="margin-bottom:20px">
            <div class="imgText">
                <div class="imgCom">
                    <img :src="item.img" :alt="item.text">
                </div>
                <div class="textBox">
                    <div class="text">{{ item.text }}</div>
                </div>
            </div>
        </el-col>
    </el-row>
</template>

<script>
export default {
    props:["imgList"]
}
</script>

<style lang="scss" scoped>
.elBg {
    transition: all 0.3s ease;
    
    .imgText {
        border-radius: vw(16);
        overflow: hidden;
        background: rgba(255, 255, 255, 0.65);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.7);
        box-shadow: 0 vw(4) vw(20) rgba(9, 30, 66, 0.05);
        transition: all 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        cursor: pointer;
        
        &:hover {
            transform: translateY(vw(-10));
            box-shadow: 0 vw(18) vw(44) rgba(9, 30, 66, 0.12);
            background: rgba(255, 255, 255, 0.95);
            border-color: rgba(9, 96, 255, 0.25);
        }
        
        .imgCom {
            width: 100%;
            aspect-ratio: 4/3;
            overflow: hidden;
            background: #f5f8fc;
            
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.7s ease;
            }
        }
        
        &:hover .imgCom img {
            transform: scale(1.1);
        }
        
        .textBox {
            padding: vw(14) 0;
            text-align: center;
            transition: all 0.3s ease;
            
            .text {
                padding: vw(6) 0;
                font-size: vw(15);
                font-weight: 500;
                color: #ffffff;
                letter-spacing: vw(1.5);
            }
        }
        
        // 交替渐变配色
        &:nth-of-type(2n) .textBox {
            background: linear-gradient(135deg, $blue096, #3a8bff);
        }
        
        &:nth-of-type(2n+1) .textBox {
            background: linear-gradient(135deg, #55a3ff, #7ab8ff);
        }
    }
}

// 手机端适配
@media only screen and (max-width: 767px) {
    .elBg {
        .imgText {
            border-radius: vp(16);
            
            .textBox {
                padding: vp(12) 0;
                
                .text {
                    font-size: vp(15);
                    padding: vp(4) 0;
                }
            }
        }
    }
}
</style>